import { Directive, ElementRef, Input, NgZone } from '@angular/core';
/**
 * Malihu Custom Scrollbar directive
 * Use this reference link for options definition
 * http://manos.malihu.gr/jquery-custom-content-scroller/
 */
export var MalihuScrollbarDirective = (function () {
    function MalihuScrollbarDirective(elementRef, zone) {
        this.elementRef = elementRef;
        this.zone = zone;
    }
    MalihuScrollbarDirective.prototype.ngAfterViewInit = function () {
        this.initElements();
        this.initScrollbar();
    };
    MalihuScrollbarDirective.prototype.ngOnDestroy = function () {
        this.destroyScrollbar();
    };
    MalihuScrollbarDirective.prototype.initElements = function () {
        this.scrollableElement = !!this.scrollElementId
            ? $("#" + this.scrollElementId)
            : $(this.elementRef.nativeElement);
        if (!!this.scrollElementId && this.scrollableElement.length === 0) {
            console.error("MalihuScrollbarDirective cannot find element with provided scrollElementId: " + this.scrollElementId + ".");
        }
    };
    MalihuScrollbarDirective.prototype.initScrollbar = function () {
        var _this = this;
        this.zone.runOutsideAngular(function () { return _this.scrollableElement.mCustomScrollbar(_this.scrollbarOptions); });
    };
    MalihuScrollbarDirective.prototype.destroyScrollbar = function () {
        var _this = this;
        this.zone.runOutsideAngular(function () { return _this.scrollableElement.mCustomScrollbar('destroy'); });
    };
    MalihuScrollbarDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[MalihuScrollbar], [malihu-scrollbar]',
                },] },
    ];
    /** @nocollapse */
    MalihuScrollbarDirective.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: NgZone, },
    ]; };
    MalihuScrollbarDirective.propDecorators = {
        'scrollElementId': [{ type: Input },],
        'scrollbarOptions': [{ type: Input },],
    };
    return MalihuScrollbarDirective;
}());
//# sourceMappingURL=malihu-scrollbar.directive.js.map


//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/ngx-malihu-scrollbar/dist/lib/malihu-scrollbar.directive.js
// module id = ../../../../ngx-malihu-scrollbar/dist/lib/malihu-scrollbar.directive.js
// module chunks = 4